export default __webpack_public_path__ + "static/media/Nunito-SemiBold.fd2e1f20.eot";